import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

export const fetchAttachmentsStarted = createAction(
  'vehicleLink/fetchAttachmentsStarted'
);
export const fetchAttachmentsSucceeded = createAction(
  'vehicleLink/fetchAttachmentsSucceeded'
);
export const fetchAttachmentsFailed = createAction(
  'vehicleLink/fetchAttachmentsFailed'
);
export const setAttachments = createAction('vehicleLink/setAttachments');

export const fetchAttachments = () => (dispatch) => {
  dispatch(fetchAttachmentsStarted());
  return EcomEngineAPI.vehicleLink
    .attachments()
    .then((response) => {
      dispatch(fetchAttachmentsSucceeded());
      dispatch(setAttachments(response));
    })
    .catch((error) => {
      trackError(error);
      dispatch(fetchAttachmentsFailed(error.message));
    });
};
